import classNames from 'classnames'
import PageHeader from '../../common/PageHeader/PageHeader'
import { useSelector } from 'react-redux'
import styles from './CoachDashboardNew.module.scss'
import DashboardHeaderNotifications from './DashboardHeaderNotifications'
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'
import CoachDashboardHome from './CoachDashboardHome'
import CoachingDashboard from './CoachingDashboard'
import EventInProgressAlert from '../../events/EventInProgressAlert'
import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { selectIsOnboardingEnabled } from '../../../reducers/coachOnboardingReducer'
import CoachOnboardingDismissModal from './coachOnboarding/CoachOnboardingDismissModal'
import BusinessDashboard from './business-dashboard/BusinessDashboard'

const CoachDashboardNew = () => {
  const community = useSelector(state => state.user.current_user.communities[0])
  const isCoachOnboardingEnabled = useSelector(selectIsOnboardingEnabled)
  const title = `${community.name} Dashboard`
  const [tabIndex, setTabIndex] = useState(0)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // TODO: Remove this once tab routes are handled by the router
    if (location.pathname === '/dashboard') {
      navigate('/dashboard/home', { replace: true })
    } else {
      if (location.pathname.includes('/business')) {
        setTabIndex(2)
      } else if (location.pathname.includes('/coaching')) {
        setTabIndex(1)
      } else {
        setTabIndex(0)
      }
    }
  }, [location, navigate])

  const tabNavigation = (index) => {
    switch (index) {
      case 0: navigate('/dashboard/home')
        break
      case 1: navigate('/dashboard/coaching')
        break
      case 2: navigate('/dashboard/business')
        break
      default:
    }
  }

  const [showEventInProgressAlert, setShowEventInProgressAlert] = useState(true)

  return (
    <div className={styles.coachDashboardNew}>
      <PageHeader
        title={title}
        iconUrl={community.photo?.file_url}
        titleUrl={`/landing/${community.id}`}
        actionComponent={<DashboardHeaderNotifications />}
      />
      <Tabs
        className={styles.tabs}
        selectedIndex={tabIndex}
        onSelect={(index) => tabNavigation(index)}
        forceRenderTabPanel={true}
      >
        {community.ongoing_events_count > 0 && showEventInProgressAlert &&
          <EventInProgressAlert
            scoresPassedDue={true}
            onClick={() => navigate('/events')}
            onClose={() => setShowEventInProgressAlert(false)}
          />
        }
        <TabList className={classNames(styles.tabList, { [styles.hideTabList]: isCoachOnboardingEnabled })}>
          <Tab className={`${styles.tab} react-tabs__tab`} selectedClassName={styles.activeTab}>Home</Tab>
          <Tab className={`${styles.tab} react-tabs__tab`} selectedClassName={styles.activeTab}>Coaching</Tab>
          <Tab className={`${styles.tab} react-tabs__tab`} selectedClassName={styles.activeTab}>Business</Tab>
        </TabList>
        <TabPanel className={styles.tabPanel}>
          <CoachDashboardHome />
        </TabPanel>
        <TabPanel className={styles.tabPanel}>
          <CoachingDashboard/>
        </TabPanel>
        <TabPanel>
          <BusinessDashboard />
        </TabPanel>
      </Tabs>
      {isCoachOnboardingEnabled && <CoachOnboardingDismissModal />}
    </div>
  )
}

export default CoachDashboardNew
